import { TILES_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { ITileOnboardResponse, ITilesUpdateBody } from "@/api_framework/api_modals/Tiles";

AxiosCurlirize(axios, () => {});
export const useTileUpdateAPI = () => {
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const configuration = useConfiguration();
  const execute = useCallback(
    async (tileName: string, body: ITilesUpdateBody): Promise<boolean> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const res: AxiosResponse<ITileOnboardResponse> = await axios.patch(
          `${TILES_MODULE?.TILES_UPDATE_API?.baseURL}${tileName}/`,
          body,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (res.data.status === true) {
          toast.success(res.data.message || "Tile updated successfully");
          return true;
        }
        toast.error(res.data.message || "Failed to update tile");
        return false;
      } catch (e: any) {
        if (axios.isAxiosError(e) && e.config) {
          sendCurl(e.config["curlCommand"]);
        }
        captureError(e);
        toast.error("Server Error: " + e.message);
        return false;
      }
    },
    [configuration, captureError, sendCurl],
  );
  return execute;
};
